export function PageHeader({ productName, items, onNavigate }) {
  return (
    <header className="page-header">
      <a className="brand" href="/" aria-label={`${productName} ホーム`}>
        <span className="brand-mark" aria-hidden="true">
          N
        </span>
        <span>{productName}</span>
      </a>

      <nav className="page-navigation" aria-label="メインナビゲーション">
        {items.map((item) => (
          <button
            className="navigation-link"
            key={item.label}
            type="button"
            onClick={() => onNavigate(item)}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  );
}
